import React, { useEffect, useRef, useState } from "react";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import axiosInstance from "../../utils/axiosInstance";
import { fetchDoctorProfile, imageBaseUrl, manageDrBankAccount, updateDoctorDetails, updateUserDetais } from "../../constants/ApiConstants";
import { useNavigate } from "react-router-dom";
import { updateDoctorData, updateUserData } from "../../store/appSlice";
import { FaCirclePlus } from "react-icons/fa6";
import TextAreaField from "../../components/TextAreaField";
import Section from "../../components/Section";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";
import MobileNumberWithCountryCode from "../../components/MobileNumberWithCountryCode";

export default function BankDetails() {
  pageTitle("Bank Details");

  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData)?.id;
  const settings = useSelector((state) => state.appSlice.settings);
  const [image, setImage] = useState(null);
  const [bankName, setBankName] = useState("");
  const [accNumber, setAccNumber] = useState("");
  const [reAccNumber, setReAccNumber] = useState("");
  const [holderName, setHolderName] = useState("");
  const [swiftCode, setSwiftCode] = useState("");

  const imageRef = useRef();

  const [imagePreview, setImagePreview] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);

    axiosInstance
      .post(fetchDoctorProfile, { doctor_id: doctorId })
      .then((res) => {
        setBankName(res?.data?.data.bank_account?.bank_name);
        setAccNumber(res?.data?.data.bank_account?.account_number);
        setReAccNumber(res?.data?.data.bank_account?.account_number);
        setHolderName(res?.data?.data?.bank_account?.holder);
        setSwiftCode(res?.data?.data.bank_account?.swift_code);
        setImagePreview(res?.data?.data?.bank_account?.cheque_photo ? `${imageBaseUrl}${res?.data?.data?.bank_account?.cheque_photo}` : null);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmitClick = async () => {
    if (!imagePreview) {
      toast.error("Cancelled Cheque Image is required");
      return;
    }
    if (bankName === "") {
      toast.error("Bank Name is required");
      return;
    }
    if (accNumber === "") {
      toast.error("Please provide Account Number");
      return;
    }
    if (reAccNumber === "") {
      toast.error("Please provide Re-Account Number");
      return;
    }
    if (holderName === "") {
      toast.error("Please provide Account Holder name");
      return;
    }
    if (swiftCode === "") {
      toast.error("Please provide Swift Code");
      return;
    }
    if (accNumber != reAccNumber) {
      toast.error("Account number and ReAccount Number does not match.");
      return;
    }
    const formdata = new FormData();
    formdata.append("doctor_id", doctorId);
    if (image && image instanceof File) {
      formdata.append("cheque_photo", image);
    }
    formdata.append("bank_name", bankName);
    formdata.append("account_number", accNumber);
    formdata.append("holder", holderName);
    formdata.append("swift_code", swiftCode);

    try {
      setLoading(true);
      const response = await axiosInstance.post(manageDrBankAccount, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data?.status) {
        toast.success("Bank details has been updated.");
        dispatch(updateDoctorData(response?.data?.data));
        navigate(-1);
      } else {
        toast.error(response.data?.message);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      // toast.error(err.response.data?.message);
      setLoading(false);
    }
  };

  const onImageClick = (event) => {
    imageRef.current.click();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(file);
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Wrapper>
      <Section topMd={0} topLg={0} topXl={0} bottomMd={0} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column px-3 gap-1 align-items-center justify-content-center">
          <CommonMobileHeader canBack={true} title={"Bank Details"} />
          <div className="col-12 col-lg-6 g-2">
            <InputField label="Bank Name" inputType={"text"} value={bankName} onChange={(e) => setBankName(e.target.value)} />
            <InputField label="Account Number" inputType={"text"} value={accNumber} onChange={(e) => setAccNumber(e.target.value)} />
            <InputField label="Re-Enter Account Number" inputType={"text"} value={reAccNumber} onChange={(e) => setReAccNumber(e.target.value)} />
            <InputField label="Holders Name" inputType={"text"} value={holderName} onChange={(e) => setHolderName(e.target.value)} />
            <InputField label="Swift Code" inputType={"text"} value={swiftCode} onChange={(e) => setSwiftCode(e.target.value)} />
            <strong className="fs-normal fw-normal mb-0 text-dark">Cancelled Cheque Photo</strong>
            <div className="col-6">
              <button type="button" onClick={onImageClick} className="bg-grey2 img-thumbnail d-flex justify-content-center align-items-center mb-3 rounded mt-3 position-relative" style={{ height: "100px", width: "100px", cursor: "pointer" }}>
                <input type="file" hidden accept="image/*" ref={imageRef} onChange={handleImageChange} />
                {imagePreview && <img className="h-100 w-100 rounded" src={imagePreview} style={{ objectFit: "cover" }} />}
                <FaCirclePlus color="gray" size={24} className="position-absolute top-45 inset-0 z-2" />
              </button>
            </div>
            <SecondaryButton title={"Submit"} className={"mt-3"} onClick={handleSubmitClick} loading={loading} />
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  padding-bottom: 60px;
`;
